import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

// --- Site web (inchangé) ---
import Accueil from './components/SiteWeb/accueil';
import Blog from './components/SiteWeb/blog';
import BlogContainer from './components/SiteWeb/blogContainer';
import DecouvrirDiagoRisk from './components/SiteWeb/decouvrirDiagoRisk';
import DiagnosticsClimatiques from './components/SiteWeb/diagnosticsClimatiques';
import MentionsLegales from './components/SiteWeb/mentionslégales';
import NousContacter from './components/SiteWeb/NousContacter';
import Projets from './components/SiteWeb/projets';
import ProtectionsDesDonnes from './components/SiteWeb/protectionsdesdonnées';
import QuiSommesNous from './components/SiteWeb/quiSommesNous';

// --- Compte ---
import Connexion from './components/Compte/Gestion_Compte/connexion';
import Inscription from './components/Compte/Gestion_Compte/inscription';
import InscriptionValidation from './components/Compte/Gestion_Compte/inscription_validation';
import Profil from './components/Compte/Gestion_Compte/profil';
import PageSimulations from './components/Compte/Simulations/page_simulations';
import CreationExploitation from './components/Compte/creation_exploitation';
import LocalisationInscription from './components/Loc_et_assol/localisation_inscription';
import Assolement from './components/Compte/Assolement/assolement';
import NewSimul from './components/Compte/Assolement/new_simul';

// --- PDF ---
import RapportPDF from './components/PDF/0_rapport_pdf';

// --- OAD hors menu ---
import Dr2050VueDensemble from './components/OAD/DiagoRisk2050/dr2050VueDensemble';
import ColzaZI from './components/OAD/ColzaZI/colzaZI';

// --- OAD : coquille + pages ---
import OADLayout from './components/layout/OADLayout';
import TableauDeBord from './components/OAD/TableauDeBord/TableauDeBord';
import ImpactsGlobaux from './components/OAD/2035-2050/ImpactsGlobaux/ImpactsGlobaux';
import BesoinEnEau from './components/OAD/2035-2050/EauEtIrrigation/BesoinEnEau';
import RentabiliteIrrigation from './components/OAD/2035-2050/EauEtIrrigation/RentabiliteIrrigation';
import Tension from './components/OAD/2035-2050/EauEtIrrigation/Tension';
import Classement from './components/OAD/2035-2050/Adaptations/Classement';
import ChangementSemisVariete from './components/OAD/2035-2050/Adaptations/ChangementSemisVariete';
import Substitution from './components/OAD/2035-2050/Adaptations/Substitution';
import ModificationITK from './components/OAD/2035-2050/Adaptations/ModificationITK';
import ComprendrePhenologie from './components/OAD/ComparerComprendre/Comprendre/Phenologie';
import ComprendreFrequenceAleas from './components/OAD/ComparerComprendre/Comprendre/FrequenceAleas';
import ComparerRisqueActuel from './components/OAD/ComparerComprendre/Comparer/RisqueActuel';
import ComparerFrequenceAleas from './components/OAD/ComparerComprendre/Comparer/FrequenceAleas';
import ComparerEau from './components/OAD/ComparerComprendre/Comparer/Eau';
import ComparerPhenologie from './components/OAD/ComparerComprendre/Comparer/Phenologie';
import Unitaire from './components/OAD/2026-2027/EauA3Mois/Unitaire';
import TotalTerritoire from './components/OAD/2026-2027/EauA3Mois/TotalTerritoire';
import OptimisationAssurance from './components/OAD/2026-2027/OptimisationAssurance/OptimisationAssurance';
import OptimisationAssolement from './components/OAD/2026-2027/OptimisationAssolement/OptimisationAssolement';

import NotFound from './notfound';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Site web */}
        <Route exact path="/" element={<Accueil />} />
        <Route exact path="/blog" element={<Blog />} />
        <Route exact path="/blog/:id" element={<BlogContainer />} />
        <Route exact path="/decouvrirDiagoRisk" element={<DecouvrirDiagoRisk />} />
        <Route exact path="/diagnostics_climatiques" element={<DiagnosticsClimatiques />} />
        <Route exact path="/mentionslegales" element={<MentionsLegales />} />
        <Route exact path="/nouscontacter" element={<NousContacter />} />
        <Route exact path="/projets" element={<Projets />} />
        <Route exact path="/protectiondesdonnees" element={<ProtectionsDesDonnes />} />
        <Route exact path="/quisommesnous" element={<QuiSommesNous />} />

        {/* Compte */}
        <Route exact path="/connexion" element={<Connexion />} />
        <Route exact path="/inscription" element={<Inscription />} />
        <Route exact path="/inscriptionvalidation" element={<InscriptionValidation />} />
        <Route exact path="/monprofil" element={<Profil />} />
        <Route exact path="/simulations" element={<PageSimulations />} />
        <Route exact path="/localisation" element={<LocalisationInscription />} />
        <Route exact path="/nouvellesimulation" element={<NewSimul />} />
        <Route exact path="/assolement" element={<Assolement />} />
        <Route exact path="/admin/crea-exploit" element={<CreationExploitation />} />

        {/* Rapport PDF */}
        <Route exact path="/previsualisationrapport" element={<RapportPDF />} />

        {/* OAD hors Menu_OAD : entete_simple seule */}
        <Route exact path="/diagorisk2050" element={<Dr2050VueDensemble />} />
        <Route exact path="/colzaZI" element={<ColzaZI />} />

        {/* OAD : coquille commune (entete_simple + Menu_OAD) */}
        <Route path="/oad" element={<OADLayout />}>
        <Route path="tableau-de-bord" element={<TableauDeBord />} />
        </Route>

        {/* Les pages à niveaux 2 et 3 partagent la même coquille, mais leurs
            segments d'URL alimentent MenuOAD via useParams. */}
        <Route path="/oad/:niveau1" element={<OADLayout />}>
        <Route path="impacts-globaux" element={<ImpactsGlobaux />} />

        <Route path="eau-irrigation/besoin-en-eau" element={<BesoinEnEau />} />
        <Route path="eau-irrigation/rentabilite-irrigation" element={<RentabiliteIrrigation />} />
        <Route path="eau-irrigation/tension" element={<Tension />} />

        <Route path="adaptations/classement" element={<Classement />} />
        <Route path="adaptations/changement-semis-variete" element={<ChangementSemisVariete />} />
        <Route path="adaptations/substitution" element={<Substitution />} />
        <Route path="adaptations/itk" element={<ModificationITK />} />

        <Route path="comprendre/pheno" element={<ComprendrePhenologie />} />
        <Route path="comprendre/frequence-aleas" element={<ComprendreFrequenceAleas />} />

        <Route path="comparer/risque-actuel" element={<ComparerRisqueActuel />} />
        <Route path="comparer/frequence-aleas" element={<ComparerFrequenceAleas />} />
        <Route path="comparer/eau" element={<ComparerEau />} />
        <Route path="comparer/pheno" element={<ComparerPhenologie />} />

        <Route path="eau-3-mois/unitaire" element={<Unitaire />} />
        <Route path="eau-3-mois/territoire" element={<TotalTerritoire />} />

        <Route path="optimisation-assurance" element={<OptimisationAssurance />} />
        <Route path="optimisation-assolement" element={<OptimisationAssolement />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
